import {memo, useMemo} from "react";
import {CONSTANTS} from "../../../../constants/constants";
import s from './OptionBtn.module.css';

const {START, END} = CONSTANTS.VALUE.POSITION_ICON_BTN;

export const OptionBtn = memo(({
  name,
  callback,
  type = 'button',
  isDisabled = false,
  isLoading = false,
  iconConfig = {},
  width = '100%',
  isActive = false,
}) => {

  const colorContent = isActive ? 'var(--color-main)' : 'var(--heading-color)';

  const {
    enabled = false,
    position = "END",
    icon = null,
  } = iconConfig;

  const Icon = useMemo(
    () => enabled ? <span className={s.icon}>{icon?.(colorContent)}</span> : null,
    [enabled, icon, colorContent]
  );

  return (
    <button
      className={s.wrapper}
      onClick={callback}
      type={type}
      disabled={isDisabled || isLoading}
      style={{width}}
    >

      <div className={s.box}>

        {!isLoading && (
          <div className={s.content}>
            {position === START && Icon}
            {name && <p className={s.name} style={{color: colorContent}}>{name}</p>}
            {position === END && Icon}
          </div>
        )}

      </div>

    </button>
  )
})